import { createDomain, sample } from 'effector'
import { rentalContractModel } from '~/entities/RentalContract'
import { AxiosErrorType, RentalContact } from '~/shared/api'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('features.rentalContract.ui.editRentalServices')

export const formSubmit = domain.createEvent<{
  rentalServices: string[]
  fn: () => void
}>()

export const formSubmitFx = domain.createEffect<
  {
    rentalServices: string[]
    fn: () => void
  },
  void,
  AxiosErrorType
>({
  async handler({ rentalServices, fn }) {
    await RentalContact.updateRentalServices(rentalServices)
    await rentalContractModel.getRentalContractSilentFx()
    fn()
  },
})

sample({
  clock: formSubmit,
  target: formSubmitFx,
})

sample({
  clock: formSubmitFx.doneData,
  fn() {
    return {
      message: 'Заявка принята',
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: formSubmitFx.failData,
  fn(e) {
    return {
      message: mapMessageErrors(e),
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})
